// 错误代码枚举

// 系统
export enum ERROR_CODE_SYSTEM {
  SysErrCode = 100001, // 系统错误
  ServiceUnavailableCode = 100002, // 服务端资源不可用
  RemoteServiceErrCode = 100003, // 远程服务出错
  PermissionDeniedCode = 100004, // 权限限制
  InvalidParamCode = 100005, // 参数错误
  TooManyRequestsCode = 100006, // 任务过多，系统繁忙
  RequestTimeoutCode = 100007, // 接口请求/任务超时
  InvalidRequestCode = 100008, // 非法请求
  NotFoundCode = 100009, // 接口不存在
  MethodNotAllowedCode = 100010, // 请求的HTTP METHOD不支持
  DeprecatedCode = 100011, // 该接口已经废弃
  IPRequestLimitCode = 100012, // IP请求超过上限
  UserRequestLimitCode = 100013, // 用户请求超过上限
  RequestEntityTooLargeCode = 100014 // 请求长度超过限制
}

// IP
export enum ERROR_CODE_IP {
  // 无效ip地址
  InvalidIpAddressCode = 101000,
  // 查询ip地址失败
  QueryFailIpLocationCode = 101001,
  // IP地址非法请求
  IllegalRequestCode = 101002
};

// 用户异常
export enum ERROR_CODE_USER {
  BackToBind = 100015, // 当前包不支持注册需要回到旧包绑定账号
  UnsupportedChainTypesCode = 102001, // 不支持的链类型
  SignatureDecodingFailedCode = 102002, // 签名解码失败
  SignatureLengthIsIncorrectCode = 102003, // 签名长度不正确
  InvalidRecoveryIDCode = 102004, // 签名恢复ID无效
  PublicKeyCannotBeRecoveredCode = 102005, // 无法恢复公钥
  SignatureAddressDoesNotMatchCode = 102006, // 签名地址不匹配
  IpAddressErrorCode = 102007, // ip地址错误
  InvalidLoginTypeCode = 102008, // 登录类型错误
  LoginTimeoutCode = 102009, // 登录超时
  CAPTCHAErrorCode = 102010, // 验证码错误
  WrongAccountPasswordCode = 102011, // 账号密码错误
  SignatureErrorCode = 102012, // 签名错误
  UserNotFindCode = 102013, // 用户不存在
  UserStatusNotNormalCode = 102014, // 用户状态异常
  IpDeviceRegisteredOvermuchCode = 102015, // 当前设备注册过多，请稍后再试
  RegisterIPLimitExceededCode = 102016, //IP注册超限
  VerifyCodeFrozenCode = 102017, //用户/IP/设备验证码被冻结
  VerifyCodeDailyLimitCode = 102018, //用户/IP/设备验证码日限制
  CaptchaRequiredCode = 102019, //需要人机验证的所有场景
  PasswordLoginForbiddenCode = 102020, //禁止密码登录
  LoginFrozenCode = 102021, //IP/设备登录被冻结
  BlacklistedCode = 102022, //用户/IP/设备进入黑名单
  TooManyAttemptsCode = 102023, //通用频率限制
  PhoneAlreadyBoundCode = 102024, //手机号已绑定
  EmailAlreadyBoundCode = 102025, //邮箱已绑定
  OldPasswordErrorCode = 102026, //旧密码错误
  PhoneOnlyRegistrationCode = 102027, //只允许手机号注册
  BindAgentFailureCode = 102028, // 绑定失败，可通过个人中心输入邀请码进行绑定，或联系客服。
  CannotBindUseOwnCode = 102029, // 不能输入自己的邀请码
  AgentRegisterTimeExceededCode = 102030, // 注册时间已超限
  AgentAlreadyBoundCode = 102031, // 用户已绑定代理
  AgentHasReferralsCode = 102032 // 已成功发展下级，不能被绑定
}

export enum ERROR_CDOE_GAME {
  MAINTENANCE = 106002, // 维护中
}